// Browser metadata capture. Everything the admin might find useful when triaging.

export interface WidgetMetadata {
  pageUrl: string;
  pageTitle: string;
  referrer: string;
  userAgent: string;
  language: string;
  viewport: { width: number; height: number };
  screen: { width: number; height: number; dpr: number };
  timestamp: string;
  timezone: string;
}

export function captureMetadata(): WidgetMetadata {
  return {
    pageUrl: redactUrl(location.href),
    pageTitle: document.title.slice(0, 200),
    referrer: redactUrl(document.referrer),
    userAgent: navigator.userAgent.slice(0, 300),
    language: navigator.language,
    viewport: {
      width: window.innerWidth,
      height: window.innerHeight,
    },
    screen: {
      width: window.screen.width,
      height: window.screen.height,
      dpr: window.devicePixelRatio ?? 1,
    },
    timestamp: new Date().toISOString(),
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  };
}

// Strip query/hash so we don't accidentally capture session tokens / PII in URLs.
function redactUrl(raw: string): string {
  if (!raw) return '';
  try {
    const u = new URL(raw);
    return `${u.origin}${u.pathname}`;
  } catch {
    return '';
  }
}
